import React, { useEffect, useState } from 'react'
import Select from 'react-select'

const Releasedate = props => {
  const {
    modeUrl,
    editData,
    releaseDate,
    active,
    // sendReleseDate,
    sendBooleanValueChangeDone,
    // noReleaseDate,
    sendinputdata,
    inputData,
    // setToBeAnnounced,
  } = props

  // const [toBeAnnounced, setToBeAnnounced] = useState(false)
  const [movieStatus, setMovieStatus] = useState(null)
  const [visible, setVisible] = useState(false)
  const statusOptions = [
    {
      value: 'MovieReleased',
      label: 'Movie Released',
    },
    {
      value: 'MovieReleaseDateRevealed',
      label: 'Movie Release Date Revealed',
    },
    { value: 'MovieOfficiallyShelved', label: 'Movie Officially Shelved' },
    { value: 'MovieReleaseDateTBA', label: 'Movie Release Date TBA' },
    { value: 'DirectlyAvailableOnOTT', label: 'Directly available on OTT' },
  ]
  const indication =
    modeUrl &&
    (editData.releaseDate === releaseDate || active.releasedate === 'TRUE')
      ? { borderColor: 'green' }
      : { borderColor: 'red' }

  const handleReleaseDate = date => {
    // sendReleseDate('releaseDate', date.target.value)
    const inputDataTemp = { ...inputData }
    inputDataTemp.releaseDate = date.target.value
    inputDataTemp.releaseDateUi = false
    sendinputdata(inputDataTemp)
    sendBooleanValueChangeDone('releasedate', true)

    // Uncheck the To Be Announced checkbox when a date is selected
    // setToBeAnnounced(false)
    // sendBooleanValueChangeDone('releaseDateUi', false)
  }

  // const handleToBeAnnouncedChange = event => {
  //   const isChecked = event.target.checked
  //   const inputDataTemp = { ...inputData }
  //   inputDataTemp.releaseDateUi = isChecked
  //   setToBeAnnounced(isChecked)
  //   if (isChecked) {
  //   inputDataTemp.releaseDate = ''
  //   // sendReleseDate('releaseDate', '')
  //   sendBooleanValueChangeDone('releasedate', true)
  // }

  // sendinputdata(inputDataTemp)
  // }

  const handleMovieStatusChange = selectedOption => {
    const newMovieStatus = selectedOption.value
    const inputDataTemp = { ...inputData, movieStatus: newMovieStatus }
    sendinputdata(inputDataTemp)
    sendBooleanValueChangeDone('releasedate', true)
    setMovieStatus(selectedOption)
  }

  useEffect(() => {
    let status = {
      value: 'MovieReleased',
      label: 'Movie Released',
    }
    let visible = true
    let tempReleaseDate = releaseDate
    const tempReleaseDateUi = ''

    if (inputData.movieStatus.includes('MovieOfficiallyShelved')) {
      status = {
        value: 'MovieOfficiallyShelved',
        label: 'Movie Officially Shelved',
      }
      visible = false
      tempReleaseDate = ''
    } else if (inputData.movieStatus.includes('MovieReleaseDateTBA')) {
      status = {
        value: 'MovieReleaseDateTBA',
        label: 'Movie Release Date TBA',
      }
      visible = false
      tempReleaseDate = ''
    } else if (inputData.movieStatus.includes('DirectlyAvailableOnOTT')) {
      status = {
        value: 'DirectlyAvailableOnOTT',
        label: 'Directly available on OTT',
      }
      visible = false
      tempReleaseDate = ''
    } else if (inputData.movieStatus.includes('MovieReleaseDateRevealed')) {
      // status =
      status = {
        value: 'MovieReleaseDateRevealed',
        label: 'Movie Release Date Revealed',
      }
      visible = true
      tempReleaseDate = releaseDate
    }

    console.log(status, 'status')
    setMovieStatus(status)
    setVisible(visible)
    const inputDataTemp = {
      ...inputData,
      releaseDate: tempReleaseDate,
      releaseDateUi: tempReleaseDateUi,
      movieStatus: status.value,
    }
    sendinputdata(inputDataTemp)
  }, [inputData.movieStatus, releaseDate])

  /*   useEffect(() => {
  if (noReleaseDate) {
  setToBeAnnounced(noReleaseDate)
  sendReleseDate('releaseDate', '')
}
  }, [noReleaseDate]) */

  return (
    <div>
      <div style={{ width: '70%' }}>
        <label className='label'>
          Movie Status:<span className='mandatory'>*</span>{' '}
        </label>
        <Select
          options={statusOptions}
          value={movieStatus}
          onChange={handleMovieStatusChange}
        />
      </div>
      <div className='shotbio'>
        {(movieStatus?.value === 'MovieReleased' ||
          movieStatus?.value === 'MovieReleaseDateRevealed') && (
          <label className='label'>Release Date:</label>
        )}
        {(movieStatus?.value === 'MovieReleased' ||
          movieStatus?.value === 'MovieReleaseDateRevealed') && (
          <input
            type='date'
            className='form-control w-75'
            value={releaseDate}
            style={modeUrl && indication}
            onChange={date => handleReleaseDate(date)}
          />
        )}
      </div>

      {/*   <div className='shotbio' style={{ display: 'flex' }}>
        <label className='label'>To Be Announced Soon:</label>
        <input
          type='checkbox'
          checked={toBeAnnounced}
          onChange={event => handleToBeAnnouncedChange(event)}
        />
            </div> */}
      {visible && !releaseDate && (
        <span className='mandatory1'>Please fill either Release Date</span>
      )}
    </div>
  )
}

export default Releasedate
